/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from 'axios'
import { devuelveBasePathPim } from '@utils'

// Función helper para obtener cookie sin dependencia externa
const getCookie = (name: string): string | undefined => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift();
    return undefined;
}

async function getResult () {
    const response = await axios.post(`${devuelveBasePathPim()}/auth/login`, {
      mail: process.env.REACT_APP_PIM_USERNAME,
      password: process.env.REACT_APP_PIM_PASSWORD
    })
    const result = response
    return result
}

if (!localStorage.getItem("bearerPim")) {
    getResult().then(result => {
        localStorage.setItem("bearerPim", result.data.token)
    })
}

// Función helper para obtener el código del idioma actual
export const getCodigoIdiomaActual = (): string => {
    return getCookie('idioma') || 'es';
}

const instance = (idiomaCodigo?: string) => { 
     if (!localStorage.getItem("bearerPim")) {
        getResult().then(result => {
            localStorage.setItem("bearerPim", result.data.token)
        })
    }
    
    const headers: any = {
        Authorization: `Bearer ${localStorage.getItem("bearerPim")}`
    };
    
    // Si no se proporciona el código de idioma, usar el idioma actual de las cookies
    const codigoIdioma = idiomaCodigo || getCodigoIdiomaActual();
    
    // Si el código de idioma es diferente a español, añadir el header
    if (codigoIdioma && codigoIdioma !== 'es') {
        headers['x-idioma-id'] = codigoIdioma;
    }
    
    return axios.create({
        baseURL: devuelveBasePathPim(), 
        headers
    }) 
}

export default instance